import { useMemo } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { MenuDot } from "../dot";
import { TextEnum } from "../../text";
import { Version } from "../../entity";
import { RootState } from "../../../store";
import { PLATFORM_TYPE_ENUM } from "../../enum";
import { CustomPopConfirm } from "../popconfirm";
import deleteIcon from "../../../static/trash.svg";
import { useAppSelector } from "../../global-hooks";
import { deleteVersion } from "../../../actions/version";

export const VersionColumns = () => {
  const { versionActionStart } = useAppSelector(
    (state: RootState) => state.version
  );

  const handleDelete = async (id: number) => {
    await deleteVersion({ id });
  };

  return useMemo(() => {
    return [
      {
        title: TextEnum.VERSION,
        key: TextEnum.VERSION,
        dataIndex: "version",
      },
      {
        title: TextEnum.PLATFORM,
        key: TextEnum.PLATFORM,
        render: (text: string, record: Version) => {
          return record.platform === PLATFORM_TYPE_ENUM.ANDROID
            ? TextEnum.ANDROID
            : TextEnum.IOS;
        },
      },
      {
        title: TextEnum.CRITICAL,
        key: TextEnum.CRITICAL,
        render: (text: string, record: Version) => {
          return <MenuDot critical={record.critical} />;
        },
      },
      {
        title: TextEnum.DELETE,
        key: TextEnum.DELETE,
        render: (text: string, record: Version) => {
          return (
            <CustomPopConfirm
              title={TextEnum.VERSION_DELETE_POPUP_CONFIRM}
              okText={TextEnum.YES}
              cancelText={TextEnum.NO}
              onConfirm={() => handleDelete(record.id)}
              disabled={false}
            >
              <button
                disabled={versionActionStart}
                className="admin-table-delete-button"
              >
                {versionActionStart ? (
                  <LoadingOutlined />
                ) : (
                  <img
                    className="table-icon"
                    src={deleteIcon}
                    alt={deleteIcon}
                  />
                )}
              </button>
            </CustomPopConfirm>
          );
        },
        width: "100px",
      },
    ];
  }, [versionActionStart]);
};
